import {
  useAcoesCelula,
  useDataCelula,
  useNomeCelula,
  usePapelCelula,
} from "./use-alocacao-celulas";
import {
  AcoesCelulaView,
  DataCelulaView,
  NomeCelulaView,
  PapelCelulaView,
} from "./view-alocacao-celulas";
import type {
  AcoesCelulaProps,
  DataCelulaProps,
  NomeCelulaProps,
  PapelCelulaProps,
} from "./types-alocacao-celulas";

export function NomeCelula(props: NomeCelulaProps) {
  const vm = useNomeCelula(props);

  return <NomeCelulaView {...props} {...vm} />;
}

export function PapelCelula(props: PapelCelulaProps) {
  const vm = usePapelCelula(props);

  return <PapelCelulaView {...props} {...vm} />;
}

export function DataCelula(props: DataCelulaProps) {
  const vm = useDataCelula(props);

  return <DataCelulaView {...props} {...vm} />;
}

export function AcoesCelula(props: AcoesCelulaProps) {
  const vm = useAcoesCelula(props);

  return <AcoesCelulaView {...props} {...vm} />;
}

export type * from "./types-alocacao-celulas";
